import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import * as Actions from './store/actions'
import { bindActionCreators } from 'redux';
import { Typography } from 'material-ui';
import { Chart } from 'react-chartjs-2';
import axios from 'axios';

import Widget1 from './widgets/Widget1';
import Widget2 from './widgets/Widget2';
import Widget3 from './widgets/Widget3';
import Widget4 from './widgets/Widget4';
import Widget5 from './widgets/Widget5';
import Widget6 from './widgets/Widget6';
import Widget7 from './widgets/Widget7';
import Widget8 from './widgets/Widget8';
import Widget9 from './widgets/Widget9';
import Widget10 from './widgets/Widget10';
import Widget11 from './widgets/Widget11';
import Widget12 from './widgets/Widget12';
import Widget13 from './widgets/Widget13';
import Widget14 from './widgets/Widget14';
import Widget15 from './widgets/Widget15';
import Widget16 from './widgets/Widget16';
import Widget17 from './widgets/Widget17';

import CalendarApp from '../calendar/CalendarApp';

const styles = theme => ({
    root: {}
});


class AdminDashboardApp extends Component {

    constructor(props) {

        super(props);

        if ("admin" == this.props.user.role || "supervisor" == this.props.user.role) {
            this.getAllJobCount();
        }

        if ("admin" == this.props.user.role) {
            this.getSumOfOutstanding();
            this.getMonthWiseSalesForecast();
            this.getSumOfTodaySales();
            this.getDataOfWeeklySales();
            this.getDataOfMonthlySales();
        }

        if ("supervisor" == this.props.user.role) {

        }

        this.state = {
            dataset: {},

            dataSetsSalesForcast: [],
            sumOfOutstanding: 0,
            totalJobCount: 0,
            pendingJobCount: 0,
            completedJobCount: 0,
            inProgressJobCount: 0,

            jobPres: [],

            sumOfTodaySales: null,

            dataOfTodaySalesAr: [],
            dataOfWeeklySalesAr: [],
            dataOfMonthlySalesAr: [],

            valueOfWidget11: 0,

            minStart :0,
            maxEnd : 0,
        }


        Chart.pluginService.register({
            afterDatasetsDraw: function (chart, easing) {
                // Only activate the plugin if it's made available
                // in the options
                if (
                    !chart.options.plugins.xLabelsOnTop ||
                    (chart.options.plugins.xLabelsOnTop && chart.options.plugins.xLabelsOnTop.active === false)
                ) {
                    return;
                }

                // To only draw at the end of animation, check for easing === 1
                const ctx = chart.ctx;

                chart.data.datasets.forEach(function (dataset, i) {
                    const meta = chart.getDatasetMeta(i);

                    if (!meta.hidden) {

                        meta.data.forEach(function (element, index) {

                            // Draw the text in black, with the specified font
                            ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
                            const fontSize = 13;
                            const fontStyle = 'normal';
                            const fontFamily = 'Roboto, Helvetica Neue, Arial';
                            ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

                            // Just naively convert to string for now
                            const dataString = dataset.data[index].toString() + 'k';

                            // Make sure alignment settings are correct
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';
                            const padding = 15;
                            const startY = 24;
                            const position = element.tooltipPosition();
                            ctx.fillText(dataString, position.x, startY);

                            ctx.save();

                            ctx.beginPath();
                            ctx.setLineDash([5, 3]);
                            ctx.moveTo(position.x, startY + padding);
                            ctx.lineTo(position.x, position.y - padding);
                            ctx.strokeStyle = 'rgba(255,255,255,0.54)';
                            ctx.stroke();

                            ctx.restore();
                        });
                    }
                });
            }
        });
    }

    getNoOfCustomers() {
        axios.get(window.crmServer + '/crm/getCustomer/min')
            .then(response => {

                if (response == undefined || response == null || response == "") {

                } else {
                    // noOfCustomers = response.data.length;
                }


            }).catch(function (error) {

                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // this.props.alert.error("No internet connection or Internal error !");
            });
    }

    // get sum of outstandig sales
    getSumOfOutstanding() {
        axios.get(window.salesServer + '/receipt/getOutstandingSum')
            .then(response => {

                if (response == undefined || response == null || response == "") {

                } else {
                    console.log(response.data.result[0].sumOfOutstanding);
                    var sumOfOutstanding = response.data.result[0].sumOfOutstanding;
                    this.setState({ sumOfOutstanding: sumOfOutstanding });
                }


            }).catch(function (error) {

                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // this.props.alert.error("No internet connection or Internal error !");
            });
    }

    // get month wise sale forecast
    getMonthWiseSalesForecast() {

        var datasets = {}

        axios.get(window.salesServer + '/invoice/getMonthWiseSalesForecast')
        // axios.get('http://localhost:5006/invoice/getMonthWiseSalesForecast')
            .then(response => {

                if (response == undefined || response == null || response == "") {

                } else {
                    console.log("Success....................");
                    console.log("year : ", response.data.result);
                    
                    var dataSetsSalesForcast = [];

                    var jan = 0;
                    var feb = 0;
                    var mar = 0;
                    var apr = 0;
                    var may = 0;
                    var jun = 0;
                    var jul = 0;
                    var aug = 0;
                    var sep = 0;
                    var oct = 0;
                    var nov = 0;
                    var dec = 0;

                    for (var i = 0; i < response.data.result.length; i++) {
                        if (1 == response.data.result[i].m) {
                            jan = parseFloat(response.data.result[i].sumOf / 1000).toFixed(1);
                        }
                        if (2 == response.data.result[i].m) {
                            feb = parseFloat(response.data.result[i].sumOf / 1000).toFixed(1);
                        }
                        if (3 == response.data.result[i].m) {
                            mar = parseFloat(response.data.result[i].sumOf / 1000).toFixed(1);
                        }
                        if (4 == response.data.result[i].m) {
                            apr = parseFloat(response.data.result[i].sumOf / 1000).toFixed(1);
                        }
                        if (5 == response.data.result[i].m) {
                            may = (parseFloat(response.data.result[i].sumOf) / 1000).toFixed(1);
                        }
                        if (6 == response.data.result[i].m) {
                            jun = (parseFloat(response.data.result[i].sumOf) / 1000).toFixed(1);
                        }
                        if (7 == response.data.result[i].m) {
                            jul = (parseFloat(response.data.result[i].sumOf) / 1000).toFixed(1);
                        }
                        if (8 == response.data.result[i].m) {
                            aug = parseFloat(response.data.result[i].sumOf / 1000).toFixed(1);
                        }
                        if (9 == response.data.result[i].m) {
                            sep = parseFloat(response.data.result[i].sumOf / 1000).toFixed(1);
                        }
                        if (10 == response.data.result[i].m) {
                            oct = parseFloat(response.data.result[i].sumOf / 1000).toFixed(1);
                        }
                        if (11 == response.data.result[i].m) {
                            nov = parseFloat(response.data.result[i].sumOf / 1000).toFixed(1);
                        }
                        if (12 == response.data.result[i].m) {
                            dec = (parseFloat(response.data.result[i].sumOf) / 1000).toFixed(1);
                        }

                    }

                    dataSetsSalesForcast = [jan, feb, mar, apr, may, jun, jul, aug, sep, oct, nov, dec];

                    this.setState({ dataSetsSalesForcast: dataSetsSalesForcast });

                    var minStart = Math.min(...dataSetsSalesForcast);
                    var maxEnd = Math.max(...dataSetsSalesForcast);
                    this.setState({minStart : minStart});
                    this.setState({maxEnd : maxEnd});
                }

            }).catch(function (error) {

                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // this.props.alert.error("No internet connection or Internal error !");
            });
    }

    // get sum of today sales
    getSumOfTodaySales() {
        axios.get(window.salesServer + '/invoice/getSumOfTodaySales')
            .then(response => {

                var sumOfTodaySales = 0;

                if (response == undefined || response == null || response == "") {
                    sumOfTodaySales = 0;
                } else {
                    console.log("response.data.result[0] ", response.data.result[0]);
                    sumOfTodaySales = response.data.result[0].today_sales_sum.toFixed(2);
                    this.getDataOfTodaySales();
                }

                this.setState({ sumOfTodaySales: sumOfTodaySales });
            }).catch(function (error) {

                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // this.props.alert.error("No internet connection or Internal error !");
            });
    }

    // set data to figure (sum of today sales)
    getDataOfTodaySales() {
        axios.get(window.salesServer + '/invoice/getDataOfTodaySales')
            .then(response => {
                console.log("--------------------------------- ", response);
                if (response == undefined || response == null || response == "") {
                    console.log("--------------------------------- ", response);
                } else {

                    if (0 == response.data.result.length) {

                    } else {

                        console.log(response.data.result);
                        var dataOfTodaySalesAr = [];

                        if (response.data.result.length <= 7) {
                            for (var i = 0; i < response.data.result.length; i++) {
                                dataOfTodaySalesAr.push(parseFloat(Math.round(response.data.result[i].NET_AMOUNT)));
                            }
                        } else {
                            for (var i = 0; i < 7; i++) {
                                dataOfTodaySalesAr.push(parseFloat(Math.round(response.data.result[i].NET_AMOUNT)));
                            }
                        }
                        this.setState({ dataOfTodaySalesAr: dataOfTodaySalesAr });
                    }
                }

            }).catch(function (error) {

                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // this.props.alert.error("No internet connection or Internal error !");
            });
    }

    // set data to figure (sum of weekly sales)
    getDataOfWeeklySales() {
        axios.get(window.salesServer + '/invoice/getDataOfWeeklySales')
            .then(response => {

                console.log("weekly : ", response.data.result[0].NET_AMOUNT);
                if (response == undefined || response == null || response == "") {

                } else {
                    if (0 == response.data.result.length) {

                    } else {

                        console.log(response.data.result);
                        var dataOfWeeklySalesAr = [];

                        if (response.data.result.length <= 7) {
                            for (var i = 0; i < response.data.result.length; i++) {
                                dataOfWeeklySalesAr.push(parseFloat(Math.round(response.data.result[i].NET_AMOUNT)));
                            }
                        } else {

                            var onePointView = parseFloat(Math.round(response.data.result.length / 7));
                            var dev7 = parseFloat(Math.round(response.data.result.length / onePointView));
                            var count = 0;

                            for (var i = 0; i < dev7; i++) {

                                count = count + dev7;
                                var sumNetAmount = 0;

                                for (var j = (count - dev7); j < count; j++) {
                                    sumNetAmount = sumNetAmount + parseFloat(Math.round(response.data.result[j].NET_AMOUNT));
                                }
                                dataOfWeeklySalesAr.push(sumNetAmount);
                            }
                        }

                        this.setState({ dataOfWeeklySalesAr: dataOfWeeklySalesAr });
                    }
                }

            }).catch(function (error) {

                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // this.props.alert.error("No internet connection or Internal error !");
            });
    }

    // set data to figure (sum of molthly sales)
    getDataOfMonthlySales() {
        axios.get(window.salesServer + '/invoice/getDataOfMonthlySales')
            .then(response => {

                console.log("Monthly Sale ", response.data.result[0].NET_AMOUNT)

                if (response == undefined || response == null || response == "") {

                } else {
                    if (0 == response.data.result.length) {

                    } else {

                        console.log(response.data.result);

                        var dataOfMonthlySalesAr = [];

                        if (response.data.result.length <= 7) {
                            for (var i = 0; i < response.data.result.length; i++) {
                                dataOfMonthlySalesAr.push(parseFloat(Math.round(response.data.result[i].NET_AMOUNT)));
                            }
                        } else {

                            var onePointView = parseFloat(Math.round(response.data.result.length / 7));
                            var dev7 = parseFloat(Math.round(response.data.result.length / onePointView));
                            var count = 0;

                            for (var i = 0; i < dev7; i++) {

                                count = count + dev7;
                                var sumNetAmount = 0;
                                console.log("count" + count);
                                for (var j = (count - dev7); j < count; j++) {
                                    sumNetAmount = sumNetAmount + parseFloat(Math.round(response.data.result[j].NET_AMOUNT));
                                }
                                console.log("sum of : " + sumNetAmount);
                                dataOfMonthlySalesAr.push(sumNetAmount);
                            }
                        }

                        this.setState({ dataOfMonthlySalesAr: dataOfMonthlySalesAr });
                    }
                }

            }).catch(function (error) {

                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // this.props.alert.error("No internet connection or Internal error !");
            });
    }

    // get all job count
    getAllJobCount() {

        axios.get(window.crmServer + '/job/min')
            .then(response => {

                console.log(response);
                console.log(response.data.length);

                if (response == undefined || response == null || response == "" || 0 == response.data.length) {
                    console.log("//////////error////////////////////////////");
                } else {

                    var totalJobCount = response.data.length;
                    var pendingJobCount = 0;
                    var completedJobCount = 0;
                    var inProgressJobCount = 0;

                    for (var i = 0; i < response.data.length; i++) {
                        if ("Pending" == response.data[i].JOB_STATUS) {
                            pendingJobCount = pendingJobCount + 1;
                        }

                        if ("Completed" == response.data[i].JOB_STATUS) {
                            completedJobCount = completedJobCount + 1;
                        }

                        if ("In Progress" == response.data[i].JOB_STATUS) {
                            inProgressJobCount = inProgressJobCount + 1;
                        }
                    }

                    this.setState({ pendingJobCount: pendingJobCount });
                    this.setState({ completedJobCount: completedJobCount });
                    this.setState({ inProgressJobCount: inProgressJobCount });
                    this.setState({ totalJobCount: totalJobCount });

                    this.setJobPres();

                }

            }).catch(function (error) {

                console.log("err " + error);
                console.log("No internet connection or Internal error///////////////////");
                // this.props.alert.error("No internet connection or Internal error !");
            });
    }

    setJobPres() {

        var totalJobCount = this.state.totalJobCount;
        var pendingJobCount = this.state.pendingJobCount;
        var completedJobCount = this.state.completedJobCount;
        var inProgressJobCount = this.state.inProgressJobCount;

        var pendinjobPres = Math.round((pendingJobCount / totalJobCount) * 100);
        var completedjobPres = Math.round((completedJobCount / totalJobCount) * 100);
        var inProgressjobPres = Math.round((inProgressJobCount / totalJobCount) * 100);

        console.log(".............................. " + pendinjobPres + " " + completedjobPres + " " + inProgressjobPres);

        var jobPres = [completedjobPres, pendinjobPres, inProgressjobPres];

        this.setState({ jobPres: jobPres });

    }

    render() {
        const { classes } = this.props;
        var widgets = null;

        var widgetName2 = null;
        var widgetName4 = null;
        var widgetName10 = null;
        var widgetName11 = null;
        var widgetName5 = null;

        var valueOfWidget2 = 0;
        var valueOfWidget4 = 0;
        var valueOfWidget10 = 0;
        // var valueOfWidget11 = 0;

        var presOfWidget4 = 0;
        var presOfWidget10 = 0;
        var presOfWidget11 = 0;

        var presLabel = "";

        if ("admin" == this.props.user.role) {
            widgetName2 = "Today Sales";
            widgetName4 = "Current Month Revenue";
            widgetName10 = "OutStanding Sales";
            widgetName11 = "Pending Job Count ";

            valueOfWidget10 = "(RS) " + this.state.sumOfOutstanding;
            presOfWidget4 = "";
            presOfWidget10 = "";
            presOfWidget11 = "";

            presLabel = "";

        } else if ("supervisor" == this.props.user.role) {
            widgetName2 = "Totel Job Count";
            widgetName4 = "Total Pending Tasks";
            widgetName10 = "Total Ongoing Tasks";
            widgetName11 = "Total Completed Tasks";

            valueOfWidget2 = this.state.totalJobCount;
            valueOfWidget4 = this.state.pendingJobCount;
            valueOfWidget10 = this.state.inProgressJobCount;
            // valueOfWidget11 = this.state.completedJobCount;

            presOfWidget4 = this.state.jobPres[1];
            presOfWidget10 = this.state.jobPres[2];
            presOfWidget11 = this.state.jobPres[0];

            presLabel = " % of Total";
        } else {

            widgetName2 = "Pending Tasks";
            widgetName4 = "Inprogress Tasks";
            widgetName10 = "Completed Tasks";
            widgetName11 = "No Of Tasks";

            valueOfWidget10 = 0;
        }

        // if ("admin" == this.props.user.role) {

        widgets = {

            widget1: {
                chartType: 'line',
                datasets: {
                    '2018': [
                        {
                            label: 'Sales',
                            data: this.state.dataSetsSalesForcast,
                            // data: [7, 8, 6, 5, 9, 7, 5, 9, 8, 7, 6, 9],
                            fill: 'start'
                        }
                    ],
                    // '2016': [
                    //     {
                    //         label: 'Sales',
                    //         data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    //         fill: 'start'
                    //     }
                    // ],
                    // '2017': [
                    //     {
                    //         label: 'Sales',
                    //         data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    //         fill: 'start'
                    //     }
                    // ]
                },

                labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                options: {
                    spanGaps: false,
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 32,
                            left: 32,
                            right: 32
                        }
                    },
                    elements: {
                        point: {
                            radius: 4,
                            borderWidth: 2,
                            hoverRadius: 4,
                            hoverBorderWidth: 2
                        },
                        line: {
                            tension: 0
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: false,
                                    drawBorder: false,
                                    tickMarkLength: 18
                                },
                                ticks: {
                                    fontColor: '#ffffff'
                                }
                            }
                        ],
                        yAxes: [
                            {
                                display: false,
                                ticks: {
                                    min: this.state.minStart,
                                    max: this.setState.maxEnd,
                                    stepSize: 0.5
                                }
                            }
                        ]
                    },
                    plugins: {
                        filler: {
                            propagate: false
                        },
                        xLabelsOnTop: {
                            active: true
                        }
                    }
                }
            },

            widget8: {
                today: this.state.sumOfTodaySales,
                change: {
                    // value: 321,
                    // percentage: 2.05
                },
                datasets: [
                    [
                        {
                            label: '1Day',
                            data: this.state.dataOfTodaySalesAr,
                            fill: false,
                            borderColor: '#5c84f1'
                        }
                    ],
                    [
                        {
                            label: '1Week',
                            data: this.state.dataOfWeeklySalesAr,
                            fill: false,
                            borderColor: '#5c84f1'
                        }
                    ],
                    [
                        {
                            label: '1Month',
                            data: this.state.dataOfMonthlySalesAr,
                            fill: false,
                            borderColor: '#5c84f1'
                        }
                    ]
                ],
                labels: ['1', '2', '3', '4', '5', '6', '7'],
                options: {
                    spanGaps: true,
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: true,
                    elements: {
                        point: {
                            radius: 2,
                            borderWidth: 1,
                            hoverRadius: 2,
                            hoverBorderWidth: 1
                        },
                        line: {
                            tension: 0
                        }
                    },
                    layout: {
                        padding: {
                            top: 24,
                            left: 16,
                            right: 16,
                            bottom: 16
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                display: false
                            }
                        ],
                        yAxes: [
                            {
                                display: true,
                                ticks: {
                                    // min: 100,
                                    // max: 500
                                }
                            }
                        ]
                    }
                }
            },

            widget2: {
                conversion: {
                    name: widgetName2,
                    value: valueOfWidget2,
                    ofTarget: 0
                },
                chartType: 'bar',
                datasets: [
                    {
                        label: 'Conversion',
                        data: [0, 0, 0, 0, 0, 0, 0]
                    }
                ],
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                options: {
                    spanGaps: false,
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 24,
                            left: 16,
                            right: 16,
                            bottom: 16
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                display: false
                            }
                        ],
                        yAxes: [
                            {
                                display: false,
                                ticks: {
                                    min: 100,
                                    max: 500
                                }
                            }
                        ]
                    }
                }
            },

            widget4: {
                visits: {
                    name: widgetName4,
                    value: valueOfWidget4,
                    ofTarget: presOfWidget4,
                    presLabel: presLabel
                },
                chartType: 'bar',
                datasets: [
                    {
                        label: 'Visits',
                        data: [0, 0, 0, 0, 0, 0, 0]
                    }
                ],
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                options: {
                    spanGaps: false,
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 24,
                            left: 16,
                            right: 16,
                            bottom: 16
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                display: false
                            }
                        ],
                        yAxes: [
                            {
                                display: false,
                                ticks: {
                                    min: 150,
                                    max: 500
                                }
                            }
                        ]
                    }
                }
            },

            widget10: {
                conversion: {
                    name: widgetName10,
                    value: valueOfWidget10,
                    ofTarget: presOfWidget10,
                    presLabel: presLabel,                   
                },
                chartType: 'bar',
                datasets: [
                    {
                        label: 'Conversion',
                        data: [0, 0, 0, 0, 0, 0, 0]
                    }
                ],
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                options: {
                    spanGaps: false,
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 24,
                            left: 16,
                            right: 16,
                            bottom: 16
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                display: false
                            }
                        ],
                        yAxes: [
                            {
                                display: false,
                                ticks: {
                                    min: 100,
                                    max: 500
                                }
                            }
                        ]
                    }
                }
            },

            widget11: {
                conversion: {
                    name: widgetName11,
                    value: this.state.pendingJobCount,
                    ofTarget: presOfWidget11,
                    presLabel: presLabel
                },
                chartType: 'bar',
                datasets: [
                    {
                        label: 'Conversion',
                        data: [0, 0, 0, 0, 0, 0, 0]
                    }
                ],
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                options: {
                    spanGaps: false,
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 24,
                            left: 16,
                            right: 16,
                            bottom: 16
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                display: false
                            }
                        ],
                        yAxes: [
                            {
                                display: false,
                                ticks: {
                                    min: 100,
                                    max: 500
                                }
                            }
                        ]
                    }
                }
            },

            widget5: {
                chartType: 'line',
                datasets: {
                    'yesterday': [
                        {
                            label: 'Visitors',
                            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                            fill: 'start'
                        },
                        {
                            label: 'Page views',
                            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                            fill: 'start'
                        }
                    ],
                    'today': [
                        {
                            label: 'Visitors',
                            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                            fill: 'start'
                        },
                        {
                            label: 'Page Views',
                            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                            fill: 'start'
                        }
                    ]
                },
                labels: ['12am', '2am', '4am', '6am', '8am', '10am', '12pm', '2pm', '4pm', '6pm', '8pm', '10pm'],
                options: {
                    spanGaps: false,
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false,
                    tooltips: {
                        position: 'nearest',
                        mode: 'index',
                        intersect: false
                    },
                    layout: {
                        padding: {
                            left: 24,
                            right: 32
                        }
                    },
                    elements: {
                        point: {
                            radius: 4,
                            borderWidth: 2,
                            hoverRadius: 4,
                            hoverBorderWidth: 2
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    fontColor: 'rgba(0,0,0,0.54)'
                                }
                            }
                        ],
                        yAxes: [
                            {
                                gridLines: {
                                    tickMarkLength: 16
                                },
                                ticks: {
                                    stepSize: 1000
                                }
                            }
                        ]
                    },
                    plugins: {
                        filler: {
                            propagate: false
                        }
                    }
                }
            },

            widget6: {
                markers: [
                    {
                        lat: 52,
                        lng: -73,
                        label: '120'
                    },
                    {
                        lat: 37,
                        lng: -104,
                        label: '498'
                    },
                    {
                        lat: 21,
                        lng: -7,
                        label: '443'
                    },
                    {
                        lat: 55,
                        lng: 75,
                        label: '332'
                    },
                    {
                        lat: 51,
                        lng: 7,
                        label: '50'
                    },
                    {
                        lat: 31,
                        lng: 12,
                        label: '221'
                    },
                    {
                        lat: 45,
                        lng: 44,
                        label: '455'
                    },
                    {
                        lat: -26,
                        lng: 134,
                        label: '231'
                    },
                    {
                        lat: -9,
                        lng: -60,
                        label: '67'
                    },
                    {
                        lat: 33,
                        lng: 104,
                        label: '665'
                    }
                ],
                styles: [
                    {
                        'featureType': 'administrative',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#444444'
                            }
                        ]
                    },
                    {
                        'featureType': 'landscape',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'color': '#f2f2f2'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'road',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'saturation': -100
                            },
                            {
                                'lightness': 45
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'simplified'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.arterial',
                        'elementType': 'labels.icon',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'transit',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'water',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'color': '#039be5'
                            },
                            {
                                'visibility': 'on'
                            }
                        ]
                    }
                ]
            },

            widget7: {
                labels: [
                    'Completed',
                    'Pending',
                    'In Progress'
                ],
                datasets: {
                    'Today': [
                        {
                            data: this.state.jobPres,
                            change: []
                        }
                    ],

                    // 'Yesterday': [
                    //     {
                    //         data: [77.2, 8.4, 14.4],
                    //         change: [-2.3, 0.3, -0.2]
                    //     }
                    // ],
                    // 'Last 7 days': [
                    //     {
                    //         data: [88.2, 9.2, 2.6],
                    //         change: [1.9, -0.4, 0.3]
                    //     }
                    // ],
                    // 'Last 28 days': [
                    //     {
                    //         data: [65.2, 2.6, 32.2],
                    //         change: [-12.6, -0.7, 4.2]
                    //     }
                    // ],
                    // 'Last 90 days': [
                    //     {
                    //         data: [93.5, 4.2, 2.3],
                    //         change: [2.6, -0.7, 2.1]
                    //     }
                    // ]
                },
                options: {
                    cutoutPercentage: 75,
                    spanGaps: false,
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false
                }
            },

            widget12: {
                markers: [
                    {
                        lat: 52,
                        lng: -73,
                        label: '120'
                    },
                    {
                        lat: 37,
                        lng: -104,
                        label: '498'
                    },
                    {
                        lat: 21,
                        lng: -7,
                        label: '443'
                    },
                    {
                        lat: 55,
                        lng: 75,
                        label: '332'
                    },
                    {
                        lat: 51,
                        lng: 7,
                        label: '50'
                    },
                    {
                        lat: 31,
                        lng: 12,
                        label: '221'
                    },
                    {
                        lat: 45,
                        lng: 44,
                        label: '455'
                    },
                    {
                        lat: -26,
                        lng: 134,
                        label: '231'
                    },
                    {
                        lat: -9,
                        lng: -60,
                        label: '67'
                    },
                    {
                        lat: 33,
                        lng: 104,
                        label: '665'
                    }
                ],
                styles: [
                    {
                        'featureType': 'administrative',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#444444'
                            }
                        ]
                    },
                    {
                        'featureType': 'landscape',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'color': '#f2f2f2'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'road',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'saturation': -100
                            },
                            {
                                'lightness': 45
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'simplified'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.arterial',
                        'elementType': 'labels.icon',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'transit',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'water',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'color': '#039be5'
                            },
                            {
                                'visibility': 'on'
                            }
                        ]
                    }
                ]
            },

            widget13: {
                markers: [
                    {
                        lat: 52,
                        lng: -73,
                        label: '120'
                    },
                    {
                        lat: 37,
                        lng: -104,
                        label: '498'
                    },
                    {
                        lat: 21,
                        lng: -7,
                        label: '443'
                    },
                    {
                        lat: 55,
                        lng: 75,
                        label: '332'
                    },
                    {
                        lat: 51,
                        lng: 7,
                        label: '50'
                    },
                    {
                        lat: 31,
                        lng: 12,
                        label: '221'
                    },
                    {
                        lat: 45,
                        lng: 44,
                        label: '455'
                    },
                    {
                        lat: -26,
                        lng: 134,
                        label: '231'
                    },
                    {
                        lat: -9,
                        lng: -60,
                        label: '67'
                    },
                    {
                        lat: 33,
                        lng: 104,
                        label: '665'
                    }
                ],
                datasets: {
                    'Next 10 Days': [
                        {
                            data: [92.8, 6.1, 1.1],
                            change: [-0.6, 0.7, 0.1]
                        }
                    ],
                    'Next 20 Days': [
                        {
                            data: [77.2, 8.4, 14.4],
                            change: [-2.3, 0.3, -0.2]
                        }
                    ],
                    'Next 30 Days': [
                        {
                            data: [77.2, 8.4, 14.4],
                            change: [-2.3, 0.3, -0.2]
                        }
                    ],

                },
                styles: [
                    {
                        'featureType': 'administrative',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#444444'
                            }
                        ]
                    },
                    {
                        'featureType': 'landscape',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'color': '#f2f2f2'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'road',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'saturation': -100
                            },
                            {
                                'lightness': 45
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'simplified'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.arterial',
                        'elementType': 'labels.icon',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'transit',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'water',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'color': '#039be5'
                            },
                            {
                                'visibility': 'on'
                            }
                        ]
                    }
                ]
            },

            widget14: {
                labels: [
                    'Inbound',
                    'Outbound',

                ],
                datasets: {
                    'Today': [
                        {
                            data: [92.8, 6.1, 1.1],
                            change: [-0.6, 0.7, 0.1]
                        }
                    ],
                    'Yesterday': [
                        {
                            data: [77.2, 8.4, 14.4],
                            change: [-2.3, 0.3, -0.2]
                        }
                    ],
                    'Last 7 days': [
                        {
                            data: [88.2, 9.2, 2.6],
                            change: [1.9, -0.4, 0.3]
                        }
                    ],
                    'Last 28 days': [
                        {
                            data: [65.2, 2.6, 32.2],
                            change: [-12.6, -0.7, 4.2]
                        }
                    ],
                    'Last 90 days': [
                        {
                            data: [93.5, 4.2, 2.3],
                            change: [2.6, -0.7, 2.1]
                        }
                    ]
                },
                options: {
                    cutoutPercentage: 75,
                    spanGaps: false,
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false
                }
            },

            widget15: {
                markers: [
                    {
                        lat: 52,
                        lng: -73,
                        label: '120'
                    },
                    {
                        lat: 37,
                        lng: -104,
                        label: '498'
                    },
                    {
                        lat: 21,
                        lng: -7,
                        label: '443'
                    },
                    {
                        lat: 55,
                        lng: 75,
                        label: '332'
                    },
                    {
                        lat: 51,
                        lng: 7,
                        label: '50'
                    },
                    {
                        lat: 31,
                        lng: 12,
                        label: '221'
                    },
                    {
                        lat: 45,
                        lng: 44,
                        label: '455'
                    },
                    {
                        lat: -26,
                        lng: 134,
                        label: '231'
                    },
                    {
                        lat: -9,
                        lng: -60,
                        label: '67'
                    },
                    {
                        lat: 33,
                        lng: 104,
                        label: '665'
                    }
                ],
                styles: [
                    {
                        'featureType': 'administrative',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#444444'
                            }
                        ]
                    },
                    {
                        'featureType': 'landscape',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'color': '#f2f2f2'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'road',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'saturation': -100
                            },
                            {
                                'lightness': 45
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'simplified'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.arterial',
                        'elementType': 'labels.icon',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'transit',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'water',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'color': '#039be5'
                            },
                            {
                                'visibility': 'on'
                            }
                        ]
                    }
                ]
            },

        }
        // }


        if (!widgets) {
            return '_________no widgets on dashboard_________';
        } else {

            if ("admin" == this.props.user.role) {
                return (

                    <div className={classes.root}>

                        <div className="flex flex-col md:flex-row p-16">

                            <div className="flex flex-1 flex-col min-w-0">
                                <div className="widget w-full sm:w-full p-8">
                                    <Widget1 data={widgets.widget1} />
                                </div>
                                <Typography className="p-16 pb-8 text-18 font-300">
                                    How are your sales?
                                </Typography>

                                <div className="flex flex-col sm:flex sm:flex-row pb-32 ">

                                    <div className="widget flex w-full sm:w-1/2 p-8">
                                        <Widget8 data={widgets.widget8} />
                                    </div>

                                    <div className="widget flex w-full sm:w-1/4 p-8">
                                        <Widget10 data={widgets.widget10} />
                                    </div>

                                    <div className="widget flex w-full sm:w-1/4 p-8">
                                        <Widget11 data={widgets.widget11} />
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-wrap w-full md:w-320 pt-8">

                                <div className="mb-32 w-full sm:w-1/2 md:w-full">

                                    <div className="widget w-full pl-16 pr-16">
                                        <Widget7 data={widgets.widget7} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-wrap w-full">

                            <div className="widget w-full md:w-1/3 pl-24">
                                <Widget16 />
                            </div>
                            <div className="widget w-full md:w-2/3 pr-24 pl-16">
                                <Widget6 data={widgets.widget6} />
                            </div>

                        </div>

                        <Typography className="p-16 pb-8 text-18 font-300">
                            Outstanding Payments
                        </Typography>

                        <div className="flex flex-wrap w-full mt-16 mb-32">
                            <div className="widget w-full pl-16 pr-16">
                                <Widget17 />
                            </div>

                        </div>
                    </div>
                )
            } else if ("supervisor" == this.props.user.role) {
                return (

                    <div className={classes.root}>

                        <div className="flex flex-col md:flex-row p-16">

                            <div className="flex flex-1 flex-col min-w-0">

                                <Typography className="p-16 pb-8 text-18 font-300">
                                    How are your tasks?
                                </Typography>

                                <div className="flex flex-col sm:flex sm:flex-row pb-32">

                                    {/* totel job count */}
                                    <div className="widget flex w-full sm:w-1/4 p-8">
                                        <Widget2 data={widgets.widget2} />
                                    </div>

                                    {/* pending tasks */}
                                    <div className="widget w-full sm:w-1/4 p-8">
                                        <Widget4 data={widgets.widget4} />
                                    </div>

                                    {/* ongoing tasks */}
                                    <div className="widget flex w-full sm:w-1/4 p-8">
                                        <Widget10 data={widgets.widget10} />
                                    </div>

                                    {/* completed tasks */}
                                    <div className="widget flex w-full sm:w-1/4 p-8">
                                        <Widget11 data={widgets.widget11} />
                                    </div>
                                </div>

                                <Typography className="px-16 pb-8 text-18 font-300">
                                    Activities
                                </Typography>

                                <div className="widget w-full p-16 pb-32">
                                    {/* table */}
                                    <Widget6 data={widgets.widget6} />
                                </div>

                                <div className="flex flex-col sm:flex sm:flex-row pb-32">

                                    <div className="flex flex-1 sm:w-2/3 flex-col min-w-0 pl-16">
                                        <Widget16 />
                                        {/* <Typography className="p-16 pb-8 text-18 font-300">
                                            Re Calibration Reminders
                                        </Typography> */}

                                        {/* <div className="widget w-full  p-16 pb-32">
                                            <Widget13 data={widgets.widget13} />
                                        </div> */}

                                    </div>
                                    <div className="flex flex-1 sm:w-1/3 flex-col min-w-0">
                                        {/* <Typography className="p-16 pb-8 text-18 font-300">
                                            Inbound / Outbound
                                        </Typography> */}
                                        {/* <div className="widget w-full  p-16 pb-32">
                                            <Widget14 data={widgets.widget14} />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (

                    <CalendarApp />
                )
            }

        }

    };
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch);
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminDashboardApp)));



// WEBPACK FOOTER //
// ./src/main/content/apps/dashboards/AdminDashboardApp.js